import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const closingCountdownApi = createApi({
  reducerPath: "closingCountdownApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ClosingCountdown"],
  endpoints: (builder) => ({
    // Get all closing countdowns
    getAllClosingCountdowns: builder.query({
      query: (params) => ({
        url: "/closing-countdown",
        params,
      }),
      providesTags: ["ClosingCountdown"],
    }),

    // Get upcoming closings
    getUpcomingClosings: builder.query({
      query: (params) => ({
        url: "/closing-countdown/upcoming",
        params,
      }),
      providesTags: ["ClosingCountdown"],
    }),

    // Get single closing countdown
    getClosingCountdownById: builder.query({
      query: (id) => `/closing-countdown/${id}`,
      providesTags: (result, error, id) => [{ type: "ClosingCountdown", id }],
    }),

    // Create closing countdown
    createClosingCountdown: builder.mutation({
      query: (data) => ({
        url: "/closing-countdown",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ClosingCountdown"],
    }),

    // Update closing countdown
    updateClosingCountdown: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/closing-countdown/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "ClosingCountdown", id },
        "ClosingCountdown",
      ],
    }),

    // Update task status
    updateClosingTask: builder.mutation({
      query: ({ id, taskId, ...data }) => ({
        url: `/closing-countdown/${id}/tasks/${taskId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "ClosingCountdown", id },
        "ClosingCountdown",
      ],
    }),

    // Delete closing countdown
    deleteClosingCountdown: builder.mutation({
      query: (id) => ({
        url: `/closing-countdown/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ClosingCountdown"],
    }),
  }),
});

export const {
  useGetAllClosingCountdownsQuery,
  useGetUpcomingClosingsQuery,
  useGetClosingCountdownByIdQuery,
  useCreateClosingCountdownMutation,
  useUpdateClosingCountdownMutation,
  useUpdateClosingTaskMutation,
  useDeleteClosingCountdownMutation,
} = closingCountdownApi;
